// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1zXJt","inputWrap":"styles_inputWrap__2isNJ","input":"styles_input__uF6rz"};